import { Component, ChangeDetectionStrategy } from '@angular/core';

@Component({
  selector: 'app-icon-down',
  templateUrl: './icon-down.component.svg',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class IconDownComponent {}
